/**
 * Tine 2.0
 * 
 * @package     Timetracker
 * @license     http://www.gnu.org/licenses/agpl.html AGPL Version 3
 * @author      Cornelius Weiss <c.weiss@metaways.de>
 * @copyright   Copyright (c) 2007-2015 Metaways Infosystems GmbH (http://www.metaways.de)
 *
 */
 
Ext.ns('Tine.Timetracker');

/**
 * moved to Ext.ux -> stub left here for backward compat
 */
Tine.Timetracker.DurationSpinner = Ext.ux.form.DurationSpinner;
Ext.reg('tinedurationspinner', Tine.Timetracker.DurationSpinner);
